import {
	BORDER_WIDTH,
	FRONT_SECTION_TOOLS_GAP,
	FRONT_SECTION_TOOLS_HEIGHT,
} from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { Size } from '@/shared/ui/size/size';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionSideProps } from '../../types/section.types';
import { FrontSectionEditor } from '../front-section-editor/front-section-editor';
import { FrontShelf } from '../front-shelf/front-shelf';
import { SectionBorder } from '../section-border/section-border';
import styles from './front-section.module.css';

export const FrontSection = ({
	className,
	sectionIndex,
	section,
	style,
	...props
}: SectionSideProps) => {
	const [isRemoveButtonVisible, setIsRemoveButtonVisible] = useState(false);
	const { t } = useTranslation();

	const getShelfStyles = (index: number) => {
		if (section.selfs.length === 2)
			return {
				marginLeft: -BORDER_WIDTH * DISPLAY_SCALE,
			};

		return {
			top: `${(100 / section.selfs.length) * index}%`,
			left: -BORDER_WIDTH * DISPLAY_SCALE,
		};
	};

	return (
		<div
			onMouseMove={() => setIsRemoveButtonVisible(true)}
			onMouseLeave={() => setIsRemoveButtonVisible(false)}
			className={clsx(styles.wrapper, className)}
			style={{
				width: (section.width + BORDER_WIDTH * 2) * DISPLAY_SCALE,
				height:
					section.height * DISPLAY_SCALE +
					FRONT_SECTION_TOOLS_HEIGHT +
					FRONT_SECTION_TOOLS_GAP,
				...style,
			}}
			{...props}
		>
			<div className={styles.actions}>
				<FrontSectionEditor
					removeButtonVisible={isRemoveButtonVisible && sectionIndex > 0}
					sectionIndex={sectionIndex}
					section={section}
				/>
			</div>
			<div className={styles.section}>
				<SectionBorder type="front" className={styles.leftSection} />
				<SectionBorder type="front" className={styles.rightSection} />
				<div
					style={{
						width: `calc(100% - ${BORDER_WIDTH * 2 * DISPLAY_SCALE}px)`,
					}}
					className={clsx(styles.shelvesWrapper, {
						[styles.shelvesEqualDistanceWrapper]: section.selfs.length === 2,
					})}
				>
					{section.selfs.map((shelf, index) => (
						<FrontShelf
							style={getShelfStyles(index)}
							sectionIndex={sectionIndex}
							className={styles.shelf}
							shelfIndex={index}
							shelf={shelf}
							key={index}
						/>
					))}
				</div>
			</div>
			<div
				style={{
					height: FRONT_SECTION_TOOLS_HEIGHT,
				}}
				className={styles.sizeWrapper}
			>
				<Size
					type="width"
					value={`${section.width} ${t('units.mm')}`}
					label={t('size.width.sectionTitle')}
					style={{
						width: `calc(100% - ${BORDER_WIDTH * 2 * DISPLAY_SCALE}px)`,
					}}
				/>
			</div>
		</div>
	);
};
